import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/admin/ProtectedRoute';
import AdminLayout from './components/admin/AdminLayout';
import Login from './components/admin/Login';
import Dashboard from './components/admin/Dashboard';
import AdminProducts from './components/admin/Products';
import ProductForm from './components/admin/ProductForm';
import ContactRequests from './components/admin/ContactRequests';
import AdminUsers from './components/admin/AdminUsers';
import AllPartCategory from './components/admin/AllPartCategory';
import AllManufacturer from './components/admin/AllManufacturer';
import AllTypeOfEquipment from './components/admin/AllTypeOfEquipment';
import AllBrand from './components/admin/AllBrand';

// Import existing components
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import CompanyOverview from './components/CompanyOverview';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Toaster 
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: '#363636',
                color: '#fff',
              },
              success: {
                duration: 3000,
                iconTheme: {
                  primary: '#4ade80',
                  secondary: '#fff',
                },
              },
              error: {
                duration: 4000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#fff',
                },
              },
            }}
          />
          
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <div className="min-h-screen bg-white">
                <Header />
                <Hero />
                <Products />
                <CompanyOverview />
                <Contact />
                <Footer />
              </div>
            } />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />
            
            <Route path="/admin" element={
              <ProtectedRoute>
                <AdminLayout>
                  <Dashboard />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/products" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminProducts />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/products/new" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductForm />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/products/:id/edit" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ProductForm />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/contact-requests" element={
              <ProtectedRoute>
                <AdminLayout>
                  <ContactRequests />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/users" element={
              <ProtectedRoute requireSuperAdmin>
                <AdminLayout>
                  <AdminUsers />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/categories" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AllPartCategory />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/manufacturers" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AllManufacturer />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/equipment-types" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AllTypeOfEquipment />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            <Route path="/admin/brands" element={
              <ProtectedRoute>
                <AdminLayout>
                  <AllBrand />
                </AdminLayout>
              </ProtectedRoute>
            } />
            
            {/* Redirect to admin dashboard */}
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;